export default "/images/abstract-plus-grid-2.png";